import { c as _c } from "react/compiler-runtime";
import { Link, LinkProps } from '@/components/links';
import ChevronRight from '@/assets/icons/heroIcons/Chevron-right.svg';
import Image from 'next/image';
interface Props extends LinkProps {
  title: string;
  image?: {
    src: string;
    alt: string;
  };
}
export function CategoryTiles(props) {
  const $ = _c(9);
  let t0;
  if ($[0] !== props.image) {
    t0 = props.image && <Image width={80} height={64} src={props.image.src} alt={props.image.alt} className="h-10 w-13 lg:h-16 lg:w-20" />;
    $[0] = props.image;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.title) {
    t1 = <span className="line-clamp-2 text-sm font-semibold text-gray-900 lg:text-xl">{props.title}</span>;
    $[2] = props.title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronRight className="ml-auto hidden lg:block" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props || $[6] !== t0 || $[7] !== t1) {
    t3 = <Link {...props} className="flex min-h-16 items-center gap-2 rounded-lg bg-blue-50 py-3 pr-2 pl-2 no-underline shadow-xs transition-colors hover:bg-white md:rounded-2xl lg:gap-4 lg:pr-5">{t0}{t1}{t2}</Link>;
    $[5] = props;
    $[6] = t0;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}